import React from "react";
import { IconNames, Tag, TagVariant } from "@tvg/design-system";
import { Handicapping, Timeform } from "@tvg/ts-types/Race";
import { getNumberSuffix } from "@tvg/utils/generalUtils";
import { Container } from "./styled-components";
import {
  getTimeformFreePickNbr,
  isTimeformFreePickTagShown,
  getHandicappingFreePickNbr,
  isHandicappingFreePickTagShown,
  getHandicappingIconName
} from "./functions";

interface Props {
  handicapping?: Handicapping;
  timeform?: Timeform;
  trackDataSource?: string;
}

type PickNumbers = "1" | "2" | "3";

const pickNumberColorMap = {
  "1": "optedin",
  "2": "info",
  "3": "warning"
};

const PickNumber = ({ handicapping, timeform, trackDataSource }: Props) => {
  const timeFormFreePick = getTimeformFreePickNbr(timeform);
  const timeformFreePickTagShown = isTimeformFreePickTagShown(
    timeform,
    trackDataSource
  );

  const handicappingFreePick = getHandicappingFreePickNbr(handicapping);
  const handicappingFreePickTagShown =
    isHandicappingFreePickTagShown(handicapping);

  return timeformFreePickTagShown || handicappingFreePickTagShown ? (
    <Container>
      {timeformFreePickTagShown && (
        <Tag
          size="m"
          variant={
            (pickNumberColorMap[
              timeFormFreePick?.toString() as PickNumbers
            ] as TagVariant) || "optedin"
          }
          label={`${timeFormFreePick}${
            timeFormFreePick ? getNumberSuffix(timeFormFreePick) : ""
          } PICK`}
          qaLabel="timeform-tag"
          icon="numberFire"
        />
      )}
      {handicappingFreePickTagShown && (
        <Tag
          size="m"
          ml={timeformFreePickTagShown ? "space-3" : 0}
          variant={
            (pickNumberColorMap[
              handicappingFreePick?.toString() as PickNumbers
            ] as TagVariant) || "optedin"
          }
          label={`${handicappingFreePick}${
            handicappingFreePick ? getNumberSuffix(handicappingFreePick) : ""
          } PICK`}
          qaLabel="handicapping-tag"
          icon={getHandicappingIconName(trackDataSource) as IconNames}
        />
      )}
    </Container>
  ) : null;
};

export default PickNumber;
